<script setup>

import {onMounted, reactive, ref} from "vue";
import {useBreadStore} from '@bread/js/store'
import Money from "@common/Form/Money";
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/vue/solid'

const props = defineProps({
  sales: Object,
  filters: Object,
  params: Object,
})
</script>
<template>
  <div class="max-w-10xl mx-auto">
    <div class="flex flex-col">
      <div class="overflow-x-auto shadow-md sm:rounded-lg">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden ">
            <table class="min-w-full divide-y divide-gray-200 table-fixed ">
              <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span
                      class="inline-flex w-full justify-between cursor-pointer">
                      Omzet/week
                    </span>
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span class="inline-flex w-full justify-between cursor-pointer">
                      Omzet/maand
                      <ArrowUpIcon v-if="params.field === 'name' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'name' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span class="inline-flex w-full justify-between cursor-pointer">
                      Toegevoegde omzet
                    </span>
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Leeggoed auto recall
                </th>
              </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(sale , index ) in props.sales" :key="sale.id" class="hover:bg-gray-100 "
                  :class="index % 2 === 0 ? undefined : 'bg-gray-50'">
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap " title="date">{{
                    sale.month
                  }}
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="sale.weekRevenue ?? 0" :id="sale.id" :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="sale.monthRevenue ?? 0" :id="sale.id" :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="sale.addedProfits ?? 0" :id="sale.id" :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money
                    :number="sale.retour_income ? sale.retour_income :  0"
                    :id="sale.id" :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
